
 

 

 

 
class AuditLogSearchCriteria 
{
    
        AddedByUserUID: string;
    
        DateFrom: Date;
    
        DateTo: Date;
    
        AuditLogCategoryCode: string;
    
}
 
export default AuditLogSearchCriteria;
 

